import React from 'react';
import styled from 'styled-components';

const Container = styled.ul`
  margin: 0;
  list-style: none;
  > li {
    cursor: pointer;
    padding: 0.6em;

    &.active {
      background: CornflowerBlue;
      cursor: default;
      color: white;
    }
  }
`;
function NodeList({ notes = [], selectedNote, onSelect }) {
  const selectedId = selectedNote && selectedNote.id ? selectedNote.id : '';
  return (
    <Container className='notes'>
      {notes.map((note) => {
        const isActive = note.id === selectedId;
        return (
          <li
            key={note.id}
            onClick={() => !isActive && onSelect(note)}
            className={isActive ? 'active' : null}
          >
            {note.title}
          </li>
        );
      })}
    </Container>
  );
}

export default NodeList;
